{
	"searchGalleries": "Search galleries",
	"algorithmVersion": "Algorithm Version: V12",
	"ariaContinueSetup": "Continue Setup",
	"ariaContinueWithCollection": "Continue With Selected Pixieset Collection",
	"ariaSelectReferenceImages": "Select AI Style Reference Images",
	"ariaSelectStyleSource": "Select Style Source",
	"ariaToggleUseLightroom": "Toggle Use Lightroom",
	"collectionEmpty": "Collection is empty",
	"dropImagesHint": "Drop images here (JPG, PNG, WEBP, HEIC, AVIF)",
	"explanationClientGallery": "Create a new AI Style instantly with your images on Pixieset.",
	"explanationEdits": "Edit a photo as a starting point and then train your AI Style overtime.",
	"explanationImages": "Upload up to {{limit}} photos edited in a consistent style to get started.",
	"fromManualEdit": "From Manual Edit",
	"fromPixiesetGalleries": "From Pixieset Galleries",
	"fromUploads": "From Uploads",
	"invalidCollection": "Invalid collection",
	"invalidFileFormat": "Please select JPEG, PNG, WEBP, HEIC, or AVIF files.",
	"selectImages": "Select Images",
	"title": "Create AI Style",
	"tooManyImages": "Please select up to {{limit}} images.",
	"useEmbeddedParameters": "Use Embedded Parameters"
}
